import { EveFooter, EveHeader } from '@ver-uds/e-verify';
import React from 'react';

const EVerify: React.FC = () => <span className="nobr">E-Verify</span>;

const MaintenanceMode: React.FC = () => {
  return (
    <div className="display-flex flex-column flex-align-center height-viewport width-full bg-base-lightest">
      <div className="width-full">
        <EveHeader showSelfTestLink={false} hideNavItems hideUserMenu hideNavigateToDashboard />
      </div>

      <main className="bg-white width-full flex-1">
        <div className="grid-container margin-top-4 margin-bottom-4">
          <h1>
            <EVerify /> is Temporarily Unavailable
          </h1>

          <p className="usa-intro">
            <EVerify /> is currently undergoing routine system maintenance. While <EVerify /> is unavailable, employers
            will not be able to access their <EVerify /> accounts. Employers must continue to complete and retain Form
            I-9 for every person hired to work for pay in the U.S. within the required timeframes.
          </p>
        </div>
      </main>

      <div className="width-full">
        <EveFooter />
      </div>
    </div>
  );
};

export default MaintenanceMode;
